"use client"

import Button from "@mui/material/Button"
import { ArrowRight, Sparkles } from "lucide-react"
import { useEffect, useState } from "react"

export default function Home() {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    setIsVisible(true)
  }, [])

  const scrollToContact = () => {
    const contactSection = document.getElementById("contact") || document.getElementById("contact-us")
    if (contactSection) {
      contactSection.scrollIntoView({
        behavior: "smooth",
        block: "start",
      })
    }
  }

  return (
    <div className="flex flex-col gap-10 w-full">

    <section
      id="home"
      className=" min-h-[100dvh] w-full flex flex-col justify-center items-center overflow-hidden pt-24 sm:pt-28 lg:pt-32 pb-10 sm:pb-12 lg:pb-24"
      style={{ scrollMarginTop: "100px" }}
    >
  
      {/* الخلفية */}
      <div className="absolute inset-0 mesh-gradient opacity-70 pointer-events-none" />

      {/* Container الرئيسي */}
      <div className=" z-10 w-full max-w-full mx-auto px-4 sm:px-6 md:px-10 lg:px-16 xl:px-20">
        
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8 xl:gap-16 items-center">

          {/* === قسم النصوص === */}
          <div className="lg:col-span-6 flex flex-col items-center lg:items-start text-center lg:text-left space-y-6 sm:space-y-8 lg:space-y-10 relative z-20">

            <div className={`inline-flex items-center gap-2 px-4 py-2 rounded-full glass-light border border-white/10 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-8"}`}>
              <Sparkles className="w-4 h-4 text-cyan-400 shrink-0" />
              <span className="text-xs sm:text-sm font-medium text-gray-200 tracking-wide">
                Powered by Multi-Layered AI Technology
              </span>
            </div>

            <h1 className={`font-bold leading-[1.1] tracking-tight transition-all duration-1000 delay-100 
              ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"} 
              text-4xl sm:text-5xl lg:text-6xl xl:text-7xl text-white`}>
              <span className="block">Smarter Claims</span>
              <span className="block mt-1 sm:mt-2 text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-teal-400">
                Fewer Denials
              </span>
            </h1>

            <p className={`text-xl sm:text-2xl md:text-3xl text-gray-300 transition-all duration-1000 delay-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
              Empower your healthcare management with{" "}
              <span className="text-white font-semibold">speed</span>,{" "}
              <span className="text-white font-semibold">accuracy</span>, and{" "}
              <span className="text-white font-semibold">reliability</span>.
            </p>

            <p className={`text-base sm:text-lg md:text-xl text-gray-400 max-w-2xl sm:max-w-3xl mx-auto lg:mx-0 transition-all duration-1000 delay-300 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
              Kayan's AI-powered claim management solutions cut through the complexity.
              We streamline your workflow to accelerate revenue.
            </p>

            <div className={`pt-6 sm:pt-8 transition-all duration-1000 delay-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
              <Button
                size="large"
                onClick={scrollToContact}
                className="w-full sm:w-auto"
                sx={{
                  background: "linear-gradient(135deg, #1e40af, #059669)",
                  color: "white",
                  padding: { xs: "14px 32px", sm: "16px 40px", lg: "18px 48px" },
                  fontSize: { xs: "1rem", sm: "1.1rem", lg: "1.2rem" },
                  fontWeight: "bold",
                  borderRadius: "99px",
                  textTransform: "none",
                  boxShadow: "0 10px 30px rgba(5, 150, 105, 0.3)",
                  "&:hover": {
                    background: "linear-gradient(135deg, #1e3a8a, #047857)",
                    transform: "translateY(-3px)",
                    boxShadow: "0 20px 40px rgba(5, 150, 105, 0.5)",
                  },
                }}
              >
                <span className="flex items-center gap-3">
                  Request a Demo
                  <ArrowRight className="w-5 h-5 sm:w-6 sm:h-6" />
                </span>
              </Button>
            </div>
          </div>

          {/* === قسم الصورة === */}
          <div className="lg:col-span-6 flex justify-center lg:justify-end items-center mt-8 lg:mt-0  z-10">
            <div className={`force-right-image  w-full max-w-[500px] sm:max-w-xl md:max-w-2xl lg:max-w-3xl transition-all duration-1000 ${isVisible ? "opacity-100 scale-100" : "opacity-0 scale-95"}`}>
              <div className=" text-center">
                <img
                  src="/1200edb2-1e42-44c6-80db-41eaaa58c537_Nero_AI_Image_Upscaler_Photo_Face_1_-removebg-preview.png"
                  alt="Kayan AI Assistant"
                  className="w-full h-auto object-contain animate-float-custom relative z-20 drop-shadow-2xl"
                />
                <div className="absolute -bottom-8 left-1/2 -translate-x-1/2 w-3/4 h-12 bg-cyan-500/20 blur-[60px] rounded-full animate-shadow-custom z-10" />
              </div>
            </div>
          </div>

        </div>
      </div>
      </section>
      </div>
  )
}